import type { GetProductCategoriesQuery } from '@vizit/api';
import { ListBox } from '@vizit/atoms';

interface CategoryItem extends Omit<GetProductCategoriesQuery['data'][number], 'breadcrumbs' | 'portfolio_id'> {
  /**
   * Breadcrumbs for Product Category Parent Levels
   * array of parent category names
   */
  breadcrumbs: string[];
}

function ProductCategoryLeveledItem(props: CategoryItem) {
  const { id, name, breadcrumbs } = props;

  return (
    <ListBox.Item className="h-fit px-5 gap-1" id={id} level="default" textValue={name} levels={breadcrumbs}>
      {name}
    </ListBox.Item>
  );
}

export { ProductCategoryLeveledItem };
export type { CategoryItem };
